var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Innovare TI - Feriados","newText":"Novo Registro","table":_vm.projectTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableView":true,"enableDelete":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }